import { TICKER_SYMBOLS } from "../lib/constants";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

function TickerRow() {
    return (
        <>
            {TICKER_SYMBOLS.map((t, i) => (
                <span
                    key={i}
                    data-testid={`ticker-item-${t.symbol.replace(/[^a-zA-Z0-9]/g, "")}`}
                    className="inline-flex items-center gap-2 px-5 border-r border-white/15 font-mono text-xs"
                >
                    <span className="text-white/70">{t.symbol}</span>
                    <span className="text-white">{t.value}</span>
                    <span className={`inline-flex items-center gap-0.5 ${t.up ? "text-[#4ade80]" : "text-[#f87171]"}`}>
                        {t.up ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
                        {t.change}
                    </span>
                </span>
            ))}
        </>
    );
}

export function StockTicker() {
    return (
        <div className="bg-ink text-white h-9 flex items-center overflow-hidden border-b border-white/10" data-testid="stock-ticker">
            <span className="hidden sm:inline-flex items-center h-full px-3 bg-accent text-white font-mono text-[10px] font-semibold uppercase tracking-widest shrink-0">
                Markets
            </span>
            <div className="relative flex-1 overflow-hidden">
                <div className="ticker-track">
                    <TickerRow />
                    <TickerRow />
                </div>
            </div>
        </div>
    );
}
